var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcreateStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M616.106667 536.832a256 256 0 1 0-272.298667 0 384.213333 384.213333 0 0 0-247.466667 343.168 15.488 15.488 0 0 0 15.658667 16H721.493333c8.32 0 14.506667-7.68 14.506667-16a16 16 0 0 0-16-16A80 80 0 0 1 640 784v-32c0-44.16 35.84-80 80-80a16 16 0 0 0 16-16c0-9.258667 1.578667-18.176 4.48-26.453333 2.389333-6.826667 1.28-14.549333-4.010667-19.370667a383.957333 383.957333 0 0 0-120.32-73.344z m343.893333 215.168a16 16 0 0 0-16-16H864v-80a16 16 0 0 0-16-16h-32-0.128a16 16 0 0 0-15.872 16v80h-80-0.128a16 16 0 0 0-15.872 16v32c0 8.832 7.168 16 16 16h80v80c0 8.832 7.168 16 16 16h32a16 16 0 0 0 16-16V800h80a16 16 0 0 0 16-16v-32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcreateStaff);
export default __webpack_public_path__ + "static/media/CcreateStaff.923cd5c3dab73c63ec2e9e988f75a6b6.svg";
export { ForwardRef as ReactComponent };